import { BusinessChecklistVM, ChecklistItem } from '@models/checklist';

export class GetAll {
	static readonly type = '[matter-checklist] get all checklists';
}

export class Get {
	static readonly type = '[matter-checklist] get single checklist';

	constructor(public payload: string) {}
}

export class CreateAll {
	static readonly type =
		'[matter-checklist] create all matter-checklist items for matter';

	constructor(public payload: BusinessChecklistVM) {}
}

export class CreateItem {
	static readonly type = '[matter-checklist] create matter-checklist item';

	constructor(public payload: ChecklistItem) {}
}

export class Update {
	static readonly type = '[matter-checklist] update matter-checklist item';

	constructor(public payload: ChecklistItem) {}
}

export class ToggleTask {
	static readonly type = '[matter-checklist] toggle task';

	constructor(public payload: { id: string; complete: boolean }) {}
}

export class ToggleAllTasks {
	static readonly type = '[matter-checklist] toggle all tasks';

	constructor(public payload: boolean) {}
}

export class RemoveAll {
	static readonly type = '[matter-checklist] remove checklist from matter';
}

export class Remove {
	static readonly type = '[matter-checklist] remove checklist item';

	constructor(public payload: string) {}
}

export class UpdateProgress {
	static readonly type = '[matter-checklist] update checklist progress';

	constructor() {}
}

export class UpdateStageOpenedState {
	static readonly type = '[matter-checklist] update stage opened state';

	constructor(public payload: { id: string; opened: boolean }) {}
}
